<template>
  <el-progress
    :class="['progress', type]"
    :type="type"
    :percentage="percentage"
    :color="customColor"
    :width="48"
  ></el-progress>
</template>

<script>
export default {
  name: "MuiProgress",
  props: {
    // 百分比
    percentage: {
      type: Number,
      default: 0,
    },
    // 类型
    type: {
      type: String,
      default: "line",
      validator: function (value) {
        return ["line", "circle"].includes(value);
      },
    },
  },

  computed: {
    customColor() {
      return this.type === "line" ? "#39B38E" : "#D6C632";
    },
  },
};
</script>

<style lang="scss" scoped>
.progress {
  &.line {
    min-width: 100px;
  }
  &.circle {
    ::v-deep .el-progress-circle {
      svg > path {
        stroke-width: 6px;
      }
    }
    ::v-deep .el-progress__text {
      font-size: 14px !important;
      font-weight: bold !important;
      color: #d6c632 !important;
    }
  }
}
</style>
